export default __webpack_public_path__ + "static/media/infernalart.eb8e7b3a.webp";